import React from 'react'
import { Link } from 'react-router-dom'
import Icons from "../../myIcon/Icons";
import { useModal } from '../../contexts/ModalContext';

export default function ModularFooter() {
  const { openQueryModal } = useModal();

  return (
    <>
      <footer className='modularfooter-section'>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-7 col-md-10 text-center'>
              <h5 className='heading'>Luxury interiors for iconic living</h5>
            </div>
            <div className='work-btns-footr'>
              <Link className="default-btn colored-btn" onClick={openQueryModal}>
                Download Brochure <Icons name="Longarrow_right" />
              </Link>

              <Link className="default-btn" onClick={openQueryModal}>
                Get in Touch <Icons name="Longarrow_right" />
              </Link>

            </div>
            <img src="/image/moduler-footer.webp" alt="Saysha" className='img-responsive' />
          </div>

          <div className='footer-bottom'>
            <div className='row align-items-center'>
              <div className='col-lg-6 col-md-6 order-2 order-md-1 order-lg-1'>
                <p>© 2025 Saysha. All Rights Reserved.</p>
              </div>

              <div className='col-lg-6 col-md-6 order-1 order-md-2 order-lg-2'>
                <div className='modularfooter-social'>
                  <ul className="footer-social">
                    <li><Link to={"https://www.facebook.com/SayshaInterior"} target="_blank" aria-label="Facebook"><Icons name="facebook" /></Link></li>

                    <li><Link to={"https://www.linkedin.com/company/saysha-interiors-pvt-ltd"} target="_blank" aria-label="linkedin"><Icons name="linkedin" /></Link></li>

                    <li><Link to={"https://in.pinterest.com/sayshainterior"} target="_blank" aria-label="pinterest"><Icons name="pinterest" /></Link></li>

                    <li><Link to={"https://twitter.com/sayshainteriors"} target="_blank" aria-label="twitter"><Icons name="twitter" /></Link></li>

                    <li><Link to={"https://youtube.com/@sayshainteriors?si=IwVIclXE3UWuoXJj"} target="_blank" aria-label="youtube"><Icons name="youtube" /></Link></li>

                    <li><Link to={"https://www.instagram.com/sayshainteriors?igsh=MXNqcXoxejJlaXF6Mg=="} target="_blank" aria-label="instagram"><Icons name="instagram" /></Link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}
